export default "__VITE_ASSET__f67H8eAK__"